module.exports = __webpack_public_path__ + "static/img/SenseBank.524bb45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/SenseBank.png
// module id = j1g9
// module chunks = 0